import moment from "moment";
import React from "react";
import {
	TORB3BackendRecord,
	TORB3Record,
} from "../../../../../redux/app/orb3/@types";
import { TORB3GroupE } from "../../../../../redux/app/orb3/groups/group-e";
import ORB3TableRows from "../ORB3TableRows";

type OwnProps = {
	orb3Record: TORB3Record | TORB3BackendRecord;
	theme?: "light" | "dark";
};
type ORB3GroupEPreviewProps = OwnProps;

function ORB3GroupEPreview(props: ORB3GroupEPreviewProps) {
	const record = props.orb3Record as TORB3GroupE;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY",
	);
	const { itemE } = record;

	function renderItemP1() {
		const startDTLocal = `${itemE.startDate}T${itemE.startTime}:00${record.timeZone}`;
		const utcStart = moment.utc(startDTLocal);
		const endDTLocal = `${itemE.endDate}T${itemE.endTime}:00${record.timeZone}`;
		const utcEnd = moment.utc(endDTLocal);
		return (
			<>
				<h4 className="font-medium uppercase">
					Start Date Time: {utcStart.format("HH:mm")} hrs UTC on{" "}
					{utcStart.format("DD-MMM-YYYY")} ({itemE.startTime} SMT on{" "}
					{moment(itemE.startDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}
					)
					<br />
					Start Position: {itemE.startPosition.latitude} /
					{itemE.startPosition.longitude}
				</h4>
				<h4 className="font-medium uppercase">
					Stop Date Time: {utcEnd.format("HH:mm")} hrs UTC on{" "}
					{utcEnd.format("DD-MMM-YYYY")} ({itemE.endTime} SMT on{" "}
					{moment(itemE.endDate, "YYYY-MM-DD").format("DD-MMM-YYYY")})
					<br />
					Stop Position: {itemE.stopPosition.latitude} /
					{itemE.stopPosition.longitude}
				</h4>
			</>
		);
	}

	function renderMain() {
		return (
			<ORB3TableRows
				record={record}
				tableRows={[
					[operationDate, "3-E", "6", renderItemP1()],
					[
						null,
						null,
						"7",
						`Avg O₂ in combustion chamber: ${itemE.avgOxygenPercent}% `,
					],
					[
						null,
						null,
						"8",
						`Furnace Temp: ${itemE.furnaceTempC}°C / Exhaust Temp: ${itemE.exhaustTempC}°C`,
					],
					[null, null, "NOTE", record.remarks],
				]}
				theme={props.theme}
			/>
		);
	}

	return renderMain();
}

export default ORB3GroupEPreview;
